// "Avisar al depósito" desde una parada (decisión D39): abre el chat con el Depósito con la tarjeta de la parada ya
// puesta, para escribir qué pasa (cliente cerrado, falta mercadería, otra dirección…).
import { Boton } from '@reparto/ui';
import { useNavigate } from 'react-router';

export function AvisarDeposito({ paradaId, className }: { paradaId: string; className?: string }) {
  const navegar = useNavigate();
  return (
    <Boton
      bloque
      variante="secundario"
      icono="chat"
      className={className}
      onClick={() => navegar(`/chat/deposito?parada=${encodeURIComponent(paradaId)}`)}
    >
      Avisar al depósito
    </Boton>
  );
}
